import { React, useState } from "react";
// import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

export default function Faq({ faq: {title, text}}) {
  const [showDesc, setShowDesc] = useState(false);  

  function handleClick() {
    setShowDesc((prevShowDescState) => !prevShowDescState);
  }

  return (
    <article className="single_faq">
      <div className="faq_header" onClick={handleClick}>
        <h4>{title}</h4>

        {showDesc ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </div>
      {showDesc && (
        <div className="faq_desc">
          <p>
            {text}
          </p>
        </div>
      )}
      <div className="underline"></div>
    </article>
  );
}
